window.addEventListener("load", () => {
  const youlead = new Youlead()
})

class Youlead {
  constructor() {
    window.ylData = window.ylData || []
    this.ylData = window.ylData

    this.language = document.documentElement.lang || "PL"

    this.followLinks()
    this.submitNewsletterForm("mc-embedded-subscribe-form")
    this.submitForm("send_shopping_list_form")
    this.submitForm("send_and_create_shopping_list_form")
    this.submitNewClientForm("new_client")
    localStorage.setItem("testowa-ramka-produkt", true)
  }

  submitNewClientForm(formId) {
    const form = document.querySelector(`#${formId}`)
    if (!form) return

    const orderType = form.dataset.orderType
    const kind = form.dataset.kind

    if (orderType === "ServiceOrder" || kind === "review") {
      form.addEventListener("submit", (event) => {
        event.preventDefault()

        try {
          Monitor.TrackForm(formId)
        } finally {
          setTimeout(() => {
            event.target.submit()
          }, 300)
        }
      })
    }
  }

  submitForm(formId) {
    const form = document.querySelector(`#${formId}`)

    if (!form) return

    form.addEventListener("submit", (event) => {
      event.preventDefault()

      try {
        Monitor.TrackForm(formId)
      } finally {
        setTimeout(() => {
          event.target.submit()
        }, 300)
      }
    })
  }

  submitNewsletterForm(formId) {
    const form = document.querySelector(`#${formId}`)

    if (!form) return

    form.addEventListener("submit", (event) => {
      event.preventDefault()

      Monitor.TrackForm(formId)

      form.innerHTML = `<div id="mce-responses" class="clear">
        <div class="response" id="mce-success-response">${this.successMessage()}</div>
      </div>`
    })
  }

  successMessage() {
    return this.language === "pl"
      ? "Dziękujemy za zapis do naszego newslettera."
      : "Thank you for subscribing to our newsletter."
  }

  followLinks() {
    document.body.addEventListener("click", (event) => {
      const target = event.target
      const link = target.closest('a[href*="#"]')

      if (!link) return

      const hash = link.href.split("#")[1]

      if (!hash) return

      this.ylData.push({ page: { extendedValue: hash } })
    })
  }
}
